import React from 'react';
import { EntitySearch } from './entity-search';
import { Routes, Route } from 'react-router-dom';
import { EntityCreate } from './entity-create';
import { EntityEdit } from './entity-edit';
import { EntityDetail } from './entity-detail';
import { Helmet } from 'react-helmet';

export const Entity: React.FC<any> = () => {
  return (
    <>
      <Helmet>
        <title>Entity</title>
      </Helmet>
      <Routes>
        <Route path="/" element={<EntitySearch />} />
        <Route path="create" element={<EntityCreate />} />
        <Route path="edit/:entityId" element={<EntityEdit />} />
        <Route path="detail/:entityId" element={<EntityDetail />} />
      </Routes>
    </>
  );
};
